<template>
	<aside class="c-advisermenu">
		<div class="c-advisermenu__float" @click="open()">
			<slot name="button"></slot>
		</div>
		<side-menu-overlay
			:is-open="isOpen"
			placement="right"
			@close="close"
			class="c-sidemenu c-advisermenu__side"
		>
			<template v-slot:body>
				<div class="c-advisermenu__content">
					<Adviser :negative="false" />
					<slot name="body"></slot>
				</div>
			</template>
		</side-menu-overlay>
	</aside>
</template>

<script>
import SideMenuOverlay from './SideMenuOverlay.vue';
import Adviser from './Adviser.vue';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'c-advisermenu',
	components: {
		SideMenuOverlay,
		Adviser,
	},
	data: () => {
		return {
			isOpen: false,
		};
	},
	methods: {
		close() {
			this.isOpen = false;
		},
		open() {
			this.isOpen = true;
		},
	},
});
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.c-advisermenu {
	&__float {
		cursor: pointer;
		z-index: 1;
		position: fixed;
		bottom: 10px;
		right: 10px;
	}

	&__content {
		padding: 0 60px;
	}
}

@media all and (max-width: 450px) {
	.c-advisermenu {
		&__content {
			padding: 0 30px;
		}
	}
}
</style>
